<template>
	<appBaseModal v-if="shouldShowModal">	
		<div slot="content">
			
			<div class="modal__head">
				<div class="modal__head__title">Measured Building Survey</div>
				<div class="modal__head__subtitle">Detailed, accurate plans to an appropriate scale.</div>
				<div class="modal__pres__controls">

					<div class="col md-4 modal__pres__control">
						<button @click="activeBtn = 'btn1'" :class="{active: activeBtn === 'btn1' }" class="outline">Info</button>
					</div>
								
					<div class="col md-4 modal__pres__control">
						<button @click="updatePresImg('service2.sample1.png'), activeBtn = 'btn2'" :class="{active: activeBtn === 'btn2' }" class="outline">Sample 1</button>
					</div>

					<div class="col md-4 modal__pres__control">
						<button @click="updatePresImg('service2.sample2.png'), activeBtn = 'btn3'" :class="{active: activeBtn === 'btn3' }" class="outline">Sample 2</button>
					</div>
					
					<div class="clearfix"></div>

				</div>
				
				<div class="clearfix"></div>
			</div>
			
			<div v-if="activeBtn === 'btn2' || activeBtn === 'btn3'">
				<div class v-if="activeBtn === 'btn2'">
						<!-- <div class="sample">
						<div class="sample__title">Topographic Surveys</div>
						<div class="sample__subtitle">From greenfield to brownfield, large or small. 2D &amp; 3D</div>
						</div> -->
					</div>
					<div class v-if="activeBtn === 'btn3'">
						<!-- <div class="sample">
						<div class="sample__title">Boundary Surveys</div>
						<div class="sample__subtitle">From Land Registry plans to Expert Witness.</div>
						</div> -->
					</div>
				<div class="modal__content modal__content--pres">
					<div class="col md-12 sample-image">
						<div v-if="activeBtn === 'btn2' || activeBtn === 'btn3'">
							<img :src="require('@/assets/images/' + modalPresImg)" alt="">
							<button class="primary pres-close sample-image-close" @click="closeModaler">Close</button>
						</div>
					</div>					
					<div class="clearfix"></div>
				</div>
			</div>
		
			<div class v-if="activeBtn === 'btn1'">
					<div class="modal__content">
						<ul>	
							<div class="col md-6">
								<li>Used by engineers, architects, designers, planners &amp; numerous technical consultants</li>
								<li>Experience in all sectors</li>
								<li>Floor Plans &amp; Elevations as standard</li>
								<li>Add Cross Sections </li>
								<li>Add Roof Plans</li>
								<li>Add Reflected Ceiling Plans</li>
							</div>
							<div class="col md-6">
								<li>Area referencing</li>
								<li>Street Scenes</li>
								<li>As built surveys</li>
								<li>3D Laser Scanning and point clouds available</li>
								<li>Please let us know your requirements, the details to be included and required scale for the drawings</li>
							</div>
						</ul>
						<div class="clearfix"></div>
						<button class="primary pres-close" @click="closeModaler">Close</button>
					</div>
				</div>
			</div>

		</div>
	</appBaseModal>
</template>

<script>
    import BaseModal from './BaseModal';
	export default {
		components : {
			appBaseModal : BaseModal
		},
		data(){
			return {
				compName : 'serviceOption2Modal',
				modalPresImg: 'pres-op--std.png',
				activeBtn:'btn1'
			}
		},
		computed : {
			shouldShowModal(){
				return this.$store.getters.getModalActive.modalName === this.compName
			}
		},
		methods: {
			updatePresImg: function (message) {
				// Vue.set(this.modalPresImg, 'test')
				// alert(this.modalPresImg)
				this.modalPresImg = message
			},
			updateServicesList: function (message) {
				// Vue.set(this.modalPresImg, 'test')
				// alert(this.modalPresImg)
				this.modalServicesList = message
			},
			closeModaler(){
				return this.$store.commit('closeModal', '');
			}		
		}

		
	}
	
</script>


// WEBPACK FOOTER //
// src/components/common/Modals/serviceOption2Modal.vue